import React, { useState } from "react";
import clsx from "classnames";
import classes from "./styles.module.scss";
import EventCard from "../EventCard";

export default function Paginations2({ resources, className }) {
  
  const itemsPerPage = 8;
  const [currentPage, setCurrentPage] = useState(1);

  const indexOfLastResource = currentPage * itemsPerPage;
  const indexOfFirstResource = indexOfLastResource - itemsPerPage;
  const currentResources = resources.slice(indexOfFirstResource, indexOfLastResource);

  const totalPages = Math.ceil(resources.length / itemsPerPage);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  return (
    <div className={clsx(className, classes.listings)}>
      <div className={classes.items}>
        {currentResources.map((item, index) => (
          <EventCard key={index} resource={item} />
        ))}
      </div>
      {
        totalPages > 1 && 
        <div className={classes.pagination}>
          <button
            className={classes.left_btn}
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
          >
            <img src="/icons/left-pagination-arrow.png" alt="left-pagination-arrow"/>
          </button>
          <div className={classes.page_counter}>
            <span>{currentPage}</span> - {totalPages}
          </div>
          <button
            className={classes.right_btn}
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
          >
            <img src="/icons/right-pagination-arrow.png" alt="right-pagination-arrow"/>
          </button>
        </div>
      }
     
    </div>
  );
}

Paginations2.defaultProps = {
  className: "",
};